<template>
  <div>
    <h4 class="titulo-component">Consultar Posição na Lista de Espera</h4>

    <div class="container-form">

      <el-form @submit.native.prevent="onSubmit" :model="dados" ref="dados" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Informe o número do protocolo" prop="protocolo" :rules="[$requiredBlur]">
              <el-input v-model="dados.protocolo" placeholder="Ex.: LE-202601-000123"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-alert v-if="erro" :title="erro" :closable="false" type="error" show-icon></el-alert>

        <div class="container-btns">
          <el-button native-type="submit" type="primary" :loading="consultando">Consultar</el-button>
        </div>
      </el-form>

      <div v-if="resultado" class="resultado">

        <el-alert v-if="resultado.aviso" type="info" :closable="false" show-icon
          :title="resultado.aviso" class="u-mb-15"></el-alert>

        <div class="posicao-box" v-if="resultado.posicao">
          <span class="posicao-label">Sua posição na lista</span>
          <span class="posicao-numero">{{ resultado.posicao }}º</span>
          <span class="posicao-obs">de {{ resultado.total_inscritos }} inscrito(s)</span>
        </div>

        <table class="tabela-resultado">
          <tbody>
            <tr><th>Protocolo</th><td>{{ resultado.protocolo }}</td></tr>
            <tr><th>Candidato</th><td>{{ resultado.nome }}</td></tr>
            <tr v-if="resultado.instituicao"><th>Escola</th><td>{{ resultado.instituicao }}</td></tr>
            <tr><th>Pontuação</th><td>{{ resultado.pontuacao }}</td></tr>
            <tr><th>Situação</th><td>{{ rotulo(resultado.situacao) }}</td></tr>
            <tr><th>Data da inscrição</th><td>{{ formata(resultado.data_inscricao) }}</td></tr>
            <tr v-if="resultado.motivo_indeferimento">
              <th>Motivo do indeferimento</th><td>{{ resultado.motivo_indeferimento }}</td>
            </tr>
          </tbody>
        </table>

        <p class="rodape-privacidade">
          Por segurança, esta consulta não exibe CPF, telefone, e-mail ou endereço.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * BLOCO D — item 64 do edital (Timbé do Sul/SC): consulta de posição pelo protocolo.
 *
 * Endpoint PÚBLICO. O backend devolve apenas o necessário — nome com iniciais, posição,
 * pontuação e situação. Nenhum dado de contato trafega aqui.
 */
export default {
  data () {
    return {
      consultando: false,
      erro: '',
      resultado: null,
      dados: { protocolo: '' }
    }
  },
  mounted () {
    // Permite chegar pela URL: /lista-espera-consulta?protocolo=LE-...
    if (this.$route.query && this.$route.query.protocolo) {
      this.dados.protocolo = this.$route.query.protocolo
      this.consultar()
    }
  },
  methods: {
    onSubmit () {
      this.$refs.dados.validate(valid => {
        if (!valid) {
          window.eventBus.$emit('alert', { msg: 'Informe o protocolo.', type: 'warning' })
          return
        }
        this.consultar()
      })
    },
    consultar () {
      this.erro = ''
      this.resultado = null
      this.consultando = true

      const protocolo = encodeURIComponent(String(this.dados.protocolo).trim())

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/consultar/${protocolo}`)
        .then(r => {
          this.consultando = false
          if (r.data && r.data.erro) { this.erro = r.data.erro; return }
          this.resultado = r.data
        })
        .catch(() => {
          this.consultando = false
          this.erro = 'Não foi possível consultar agora. Tente novamente em alguns instantes.'
        })
    },
    formata (d) { return d ? String(d).substring(0, 10).split('-').reverse().join('/') : '—' },
    rotulo (s) {
      const r = {
        inscrito: 'Inscrito', classificado: 'Classificado', encaminhado: 'Encaminhado para a escola',
        matriculado: 'Matriculado', indeferido: 'Indeferido', lista_espera: 'Lista de espera', cancelado: 'Cancelado'
      }
      return r[s] || s
    }
  }
}
</script>
<style scoped>
/*
   Espaçamento entre rótulo e campo, alinhado ao formulário de inscrição de novatos.

   Aquela tela usa um `<label>` comum dentro do item (sem padding) e item com 10px de
   margem. Aqui usamos o `label` do Element com `label-position="top"`, que traz
   `padding: 0 0 10px` — daí a folga maior. Medido: 10px de padding e 18px de margem
   contra 0 e 10px do modelo.
*/
::v-deep .el-form--label-top .el-form-item__label {
    padding-bottom: 2px;
    line-height: 1.4;
}

::v-deep .el-form-item {
    margin-bottom: 10px;
}

.resultado { margin-top: 26px; }
.posicao-box { text-align: center; margin: 20px 0; padding: 20px; border: 2px solid #409eff; border-radius: 6px; }
.posicao-label { display: block; font-size: 13px; color: #666; }
.posicao-numero { display: block; font-size: 40px; font-weight: bold; color: #409eff; line-height: 1.2; }
.posicao-obs { display: block; font-size: 12px; color: #888; }
.tabela-resultado { width: 100%; border-collapse: collapse; margin-top: 10px; }
.tabela-resultado th, .tabela-resultado td { border: 1px solid #e6e6e6; padding: 8px 10px; font-size: 13px; text-align: left; }
.tabela-resultado th { background: #fafafa; width: 40%; font-weight: 600; color: #555; }
.rodape-privacidade { margin-top: 14px; font-size: 12px; color: #888; text-align: center; }
</style>
